/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../assets/Icons";
import AmountToWords from "../../../components/_utils/AmountToWords";
import IconRoundButton from "../../../components/_utils/CommonButtons/IconRoundButton";
import PrimaryButton from "../../../components/_utils/CommonButtons/PrimaryButton";
import FormatAmount from "../../../components/_utils/FormatAmount/FormatAmount";
import PaginationComponent from "../../../components/_utils/PaginationComponent";
import SVGComponent from "../../../components/_utils/SVGComponent";
import Loader from "../../../components/Loader/Index";
import {
  downloadInvoice,
  getInvoices,
  invoiceId,
} from "../../../redux/features/Settings/Management/Invoices";
import {
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../utils/configurationProvider";
import { rawDateConvertior } from "../../../utils/rawDateConvertior";
import "./index.css";

const InvoicesDetail = () => {
  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedValue, setSelectedValue] = useState(
    PaginationConfiguration.paginationSmall,
  );
  const [pageSize, setPageSize] = useState(
    PaginationConfiguration.paginationSmall,
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [isOpen, setIsOpen] = useState(false);
  const [viewStatement, setViewStatement] = useState(false);

  const { isLoading, invoiceData, specificData } = useSelector(
    (state) => state.invoicesSlice,
  );
  const formatNumericDate = (isoDate) => {
    if (!isoDate || typeof isoDate !== "string") return "-";

    const parts = isoDate.split("-");
    if (parts.length !== 3) return "-";

    const [year, month, day] = parts;

    return `${Number(day)}-${Number(month)}-${year}`;
  };

  const [animate, setAnimate] = useState(false);
  const homeNavigate = () => {
    navigate("/home");
  };

  const singleStatement = (id) => {
    dispatch(invoiceId(id)).then((x) => {
      setAnimate(false);
      setViewStatement(true);
    });
  };

  const handlePagination = (page) => {
    setCurrentPage(page);
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleSelect = (value) => {
    setSelectedValue(value);
    setPageSize(value);
    setCurrentPage(Number(currentPage));
    toggleDropdown();
  };

  useEffect(() => {
    dispatch(getInvoices({ page_size: pageSize, page_no: currentPage }));
  }, [pageSize, currentPage]);

  const backBtn = () => {
    navigate(-1);
  };

  const refresh = () => {
    dispatch(
      getInvoices({ page_size: PaginationConfiguration.paginationSmall }),
    );
  };

  return (
    <>
      <div
        style={{
          zIndex: "var(--z-index-fixed-ui)",
          width: "var(--width-full)",
          bottom: "var(--bottom-base)",
          borderRadius: "var(--border-none)",
        }}
        className="fixed w-width-full"
      >
        <PaginationComponent
          handleSelect={handleSelect}
          selectedValue={selectedValue}
          data={invoiceData}
          pageSize={pageSize}
          dropdownOptions={dropdownOptions}
          handlePagination={handlePagination}
          currentPage={currentPage}
          setIsOpen={setIsOpen}
        />
      </div>

      {viewStatement && (
        <div className="specific fixed top-top-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-max bg-opacity-dark-opacity">
          <div
            className={`animate-none  max-w-full max-h-screen overflow-y-auto rounded-border-radius-md bg-primary-card p-padding-md flex flex-col gap-gap-md mx-auto absolute ${animate ? "animate-slideInFromLeftSmallPopUp" : "animate-slideInFromRightSmallPopUp"}`}
          >
            <div>
              <div className="flex items-center justify-between">
                <div className="flex">
                  <p className="text-font-md font-sans font-semibold text-text-primary ">
                    Invoice no. - {specificData?.invoice?.invoice_number}
                  </p>
                </div>
                <IconRoundButton
                  handleFunction={() => {
                    setAnimate(true);
                    setTimeout(() => {
                      setViewStatement(false);
                    }, IntervalConfiguration.intervalSemiMid);
                  }}
                  enabledBgColor="var(--primary-nav-act)"
                  icon={ICONS?.CLOSE}
                  hoverOption="white"
                  title="Close"
                />
              </div>
              <div className="max-w-full overflow-y-auto border border-primary-bg rounded-md mt-margin-md mb-margin-md">
                <div className="bg-primary-nav rounded-md">
                  <div className="flex">
                    <div className="w-width-md mt-margin-md mb-margin-md pl-padding-md">
                      <div className="flex mb-margin-xs">
                        <p className="text-font-sm text-text-secondary">
                          Invoice Number :
                        </p>
                        <span className="text-text-primary text-font-sm pl-padding-xs">
                          {specificData?.invoice?.invoice_number}
                        </span>
                      </div>
                      <div className="flex mb-margin-xs">
                        <p className="text-font-sm text-text-secondary">
                          Dated :
                        </p>
                        <span className="text-text-primary text-font-sm pl-padding-xs">
                          {rawDateConvertior(
                            specificData?.invoice?.invoice_date,
                          )}
                        </span>
                      </div>
                      <div className="flex ">
                        <p className="text-font-sm text-text-secondary">
                          Mode/Terms of Payment :
                        </p>
                        <span className="text-text-primary text-font-sm pl-padding-xs">
                          {specificData?.invoice?.terms_of_payment}
                        </span>
                      </div>
                    </div>
                    <div className="w-width-md border-l border-primary-bg mt-margin-md mb-margin-md pl-padding-md">
                      <div className="flex mb-margin-xs">
                        <p className="text-font-sm text-text-secondary">
                          Entity ID :
                        </p>
                        <span className="text-text-primary text-font-sm pl-padding-xs">
                          {specificData?.invoice?.entity_id}
                        </span>
                      </div>
                      <div className="flex mb-margin-xs">
                        <p className="text-font-sm text-text-secondary">
                          Start Date :
                        </p>
                        <span className="text-text-primary text-font-sm pl-padding-xs">
                          {rawDateConvertior(specificData?.invoice?.start_date)}
                        </span>
                      </div>
                      <div className="flex ">
                        <p className="text-font-sm text-text-secondary">
                          End Date :
                        </p>
                        <span className="text-text-primary text-font-sm pl-padding-xs">
                          {rawDateConvertior(specificData?.invoice?.end_date)}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="m-margin-md">
                  <table
                    className="table-auto w-width-full border border-primary-bg rounded-border-radius-sm"
                    style={{
                      borderCollapse: "separate",
                      borderSpacing: "var(--border-none)",
                    }}
                  >
                    <thead className="bg-primary-nav h-icon-lg rounded-t-border-radius-sm">
                      <tr className="text-text-primary">
                        <th className="border-r border-primary-bg text-sm rounded-tl-border-radius-sm font-normal">
                          Sr. No
                        </th>
                        <th className="border-r border-primary-bg text-sm font-normal">
                          Particulars
                        </th>
                        <th className="border-r border-primary-bg text-sm font-normal">
                          HSN/SAC
                        </th>
                        <th className="border-r border-primary-bg text-sm font-normal">
                          No. of Accounts
                        </th>
                        <th className="border-r border-primary-bg text-sm font-normal">
                          Rate per A/c
                        </th>
                        <th className="text-sm rounded-tr-border-radius-sm font-normal">
                          Amount(INR){" "}
                        </th>
                      </tr>
                    </thead>
                    <tbody className="text-text-primary">
                      <tr className="text-sm">
                        <td className="border-r border-t border-primary-bg text-center">
                          <p>1</p>
                        </td>
                        <td className="border-r border-t border-primary-bg capitalize">
                          {specificData?.invoice?.items.map((items, index) => {
                            return (
                              <React.Fragment key={index}>
                                <p className="pt-padding-sm pl-padding-md">
                                  {items.description}
                                </p>
                              </React.Fragment>
                            );
                          })}
                        </td>
                        <td className="border-r border-t border-primary-bg">
                          {specificData?.invoice?.items.map((items, index) => {
                            return (
                              <React.Fragment key={index}>
                                <p className="h-icon-lg pt-padding-sm text-center">
                                  {items.hsn}
                                </p>
                              </React.Fragment>
                            );
                          })}
                        </td>
                        <td className="border-r border-t border-primary-bg">
                          {specificData?.invoice?.items.map((items, index) => {
                            return (
                              <React.Fragment key={index}>
                                <p className="h-icon-lg pt-padding-sm text-center">
                                  {items.quantity}
                                </p>
                              </React.Fragment>
                            );
                          })}
                        </td>
                        <td className="border-r border-t border-primary-bg">
                          {specificData?.invoice?.items.map((items, index) => {
                            return (
                              <React.Fragment key={index}>
                                <p className="h-icon-lg pt-padding-sm text-right pr-padding-sm">
                                  INR <FormatAmount price={items.unit_price} />
                                </p>
                              </React.Fragment>
                            );
                          })}
                        </td>

                        <td className="border-t border-primary-bg">
                          {specificData?.invoice?.items.map((items, index) => {
                            return (
                              <React.Fragment key={index}>
                                <p className="h-icon-lg pt-padding-sm text-right pr-padding-sm">
                                  INR <FormatAmount price={items.total} />
                                </p>
                              </React.Fragment>
                            );
                          })}
                        </td>
                      </tr>
                      <tr className="text-sm">
                        <td className="border-r border-t border-primary-bg text-center">
                          <p>2</p>
                        </td>
                        <td className="border-r border-t border-primary-bg">
                          {specificData?.invoice?.discounts.map(
                            (discount, index) => {
                              return (
                                <React.Fragment key={index}>
                                  <p className="h-icon-lg pt-padding-sm pl-padding-md">
                                    {discount.title}
                                  </p>
                                </React.Fragment>
                              );
                            },
                          )}
                        </td>
                        <td className="border-r border-t border-primary-bg"></td>
                        <td className="border-r border-t border-primary-bg"></td>
                        <td className="border-r border-t border-primary-bg">
                          {specificData?.invoice?.discounts.map(
                            (discount, index) => {
                              return (
                                <React.Fragment key={index}>
                                  <p className="h-icon-lg pt-padding-sm text-right pr-padding-sm">
                                    {discount?.rate} %
                                  </p>
                                </React.Fragment>
                              );
                            },
                          )}
                        </td>

                        <td className="border-t border-primary-bg">
                          {specificData?.invoice?.discounts.map(
                            (discount, index) => {
                              return (
                                <React.Fragment key={index}>
                                  <p className="h-icon-lg pt-padding-sm text-right pr-padding-sm">
                                    - INR{" "}
                                    <FormatAmount price={discount.amount} />
                                  </p>
                                </React.Fragment>
                              );
                            },
                          )}
                        </td>
                      </tr>
                      <tr className="text-sm">
                        <td className="border-r border-t border-primary-bg text-center">
                          <p>3</p>
                        </td>
                        <td className="border-r border-t border-primary-bg">
                          {specificData?.invoice?.taxes.map((tax, index) => {
                            return (
                              <React.Fragment key={index}>
                                <p className="h-icon-lg pt-padding-sm pl-padding-md">
                                  {Object.keys(tax)[0].toLocaleUpperCase()}
                                </p>{" "}
                              </React.Fragment>
                            );
                          })}
                        </td>
                        <td className="border-r border-t border-primary-bg"></td>
                        <td className="border-r border-t border-primary-bg"></td>
                        <td className="border-r border-t border-primary-bg text-right pr-padding-sm pt-padding-sm ">
                          {specificData?.invoice?.taxes.map((tax, index) => {
                            return (
                              <React.Fragment key={index}>
                                {tax.cgst && (
                                  <p className="h-icon-lg">
                                    {tax.cgst?.rate} %
                                  </p>
                                )}
                                {tax.sgst && (
                                  <p className="h-icon-lg">
                                    {tax.sgst?.rate} %
                                  </p>
                                )}
                              </React.Fragment>
                            );
                          })}
                        </td>

                        <td className="border-t border-primary-bg text-right pr-padding-sm pt-padding-sm ">
                          {specificData?.invoice?.taxes.map((tax, index) => {
                            return (
                              <React.Fragment key={index}>
                                {tax.cgst && (
                                  <p className="h-icon-lg">
                                    {" "}
                                    + INR{" "}
                                    <FormatAmount price={tax.cgst?.amount} />
                                  </p>
                                )}
                                {tax.sgst && (
                                  <p className="h-icon-lg">
                                    {" "}
                                    + INR{" "}
                                    <FormatAmount price={tax.sgst?.amount} />
                                  </p>
                                )}
                              </React.Fragment>
                            );
                          })}
                        </td>
                      </tr>
                      <tr className="bg-primary-nav h-icon-lg text-sm border-t border-primary-bg ">
                        <td className="rounded-bl-border-radius-sm border-t border-primary-bg"></td>
                        <td className="h-icon-lg py-padding-sm pl-padding-md font-semibold border-t border-primary-bg">
                          <p>Final amount due</p>
                        </td>
                        <td className="border-t border-primary-bg"></td>
                        <td className="border-t border-primary-bg"></td>
                        <td className="border-t border-primary-bg"> </td>

                        <td className="text-right pr-padding-sm rounded-br-border-radius-sm border-t border-primary-bg">
                          <p>
                            INR{" "}
                            <FormatAmount
                              price={
                                specificData?.invoice?.totals?.final_amount_due
                              }
                            />
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="mb-margin-sm border border-primary-bg mx-margin-md"></div>
                <div className="px-padding-md">
                  <div className="flex justify-between">
                    <p className="text-text-primary capitalize font-normal">
                      Amount chargeable in words :
                      {AmountToWords(
                        specificData?.invoice?.totals?.final_amount_due,
                      )}
                    </p>
                    <span className="italic text-text-secondary">E. & O.E</span>
                  </div>
                  <div className="my-margin-md">
                    <p className="text-text-primary mb-margin-xs ">
                      Bank Details
                    </p>
                    <div className="flex mb-margin-xs">
                      <p className="text-font-sm text-text-secondary ">
                        Bank Name :
                      </p>
                      <span className="text-text-primary text-font-sm pl-padding-xs">
                        {specificData?.invoice?.bank_details?.bank}
                      </span>
                    </div>
                    <div className="flex mb-margin-xs">
                      <p className="text-font-sm text-text-secondary">
                        Account number :
                      </p>
                      <span className="text-text-primary text-font-sm pl-padding-xs">
                        {specificData?.invoice?.bank_details?.account_number}
                      </span>
                    </div>
                    <div className="flex mb-margin-xs">
                      <p className="text-font-sm text-text-secondary">
                        Branch & IFSC code :
                      </p>
                      <span className="text-text-primary text-font-sm pl-padding-xs">
                        {specificData?.invoice?.bank_details?.branch} &
                        <span className="text-text-primary text-font-sm pl-padding-xs">
                          {specificData?.invoice?.bank_details?.ifsc_code}
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <button
                onClick={() => {
                  dispatch(downloadInvoice(specificData?.invoice?.id));
                }}
                className=" py-padding-sm flex justify-center items-center w-width-full rounded-border-radius-sm bg-failed text-text-primary m-auto relative z-z-index-base global-hover-white"
              >
                <img
                  className="w-icon-md h-icon-md mr-margin-sm"
                  src={ICONS?.DOWNLOAD_STATEMENT}
                  alt="download"
                />
                <p className="text-font-sm">Download PDF</p>
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="flex flex-col h-screen overflow-y-hidden bg-primary-bg">
        <div className="NavBar-Main">
          <div className="hidden Qsmd:flex h-navbar-breadcrumb-height"></div>
          <div className="Main-Content_In flex">
            <div className="Total gap-gap-md !pl-padding-md Qsmd:!pl-padding-xl">
              <div
                className="flex Qsmd:hidden items-center cursor-pointer"
                onClick={backBtn}
              >
                <SVGComponent
                  url={ICONS?.ARROW_LEFT_WHITE}
                  color={"var(--text-primary)"}
                  width="var(--icon-sm)"
                  height="var(--icon-sm)"
                />
              </div>
              <div className="">
                <p className="Main_Number font-semibold">
                  {invoiceData?.total_count ? invoiceData?.total_count : "0"}
                </p>
                <p className="Number_Count font-sans">Total invoices</p>
              </div>
            </div>
            <div className="my-margin-sm mr-margin-sm ">
              <IconRoundButton
                handleFunction={refresh}
                enabledBgColor="var(--primary-nav-act)"
                icon={ICONS?.RELOAD_REFRESH_WHITE}
                hoverOption="white"
                title="Refresh"
              />
            </div>
          </div>
        </div>
        {invoiceData?.invoices && invoiceData.invoices.length ? (
          <div className="Data-Table">
            <div className="Each-Card font-sans">Date</div>
            <div className="Each-Card font-sans">Invoice No.</div>
            <div className="Each-Card font-sans">Amount</div>
            <div className="Last-Card font-sans">Action</div>
          </div>
        ) : isLoading ? (
          ""
        ) : (
          <div className="m-auto w-graphic-width-md h-graphic-rectangle-height-md flex flex-col items-center">
            <img
              src={ICONS?.NO_DATA_FOUND}
              alt="no data found"
            />
            <p className="text-text-primary text-sm py-padding-sm">
              No data found
            </p>
            <PrimaryButton
              btnText={"Home dashboard"}
              handleFunction={homeNavigate}
              enabledTextColor="var(--text-primary)"
              enabledBgColor="var(--primary-act)"
              hoverOption="white"
            />
          </div>
        )}

        {isLoading ? (
          <div className="loader-container m-auto justify-center items-center flex">
            <Loader />
          </div>
        ) : (
          <div className="data-show">
            {invoiceData?.invoices?.map((data) => (
              <div
                key={data?.id}
                className="Table-Data"
              >
                <div className="firstmain">
                  <div className="first-Data">
                    <span className="dateNumber">
                      {formatNumericDate(data?.invoice_date)}
                    </span>

                    <p className="dateFirst">Date</p>
                  </div>
                  {/* <div className="statusCard">
                    <p
                      className={`${
                        data.status === "paid" ? "paid" : "unpaid"
                      } capitalize`}
                    >
                      {data.status}
                    </p>
                  </div> */}
                </div>
                <div className="second-Data">
                  <span className="dataInvoice">{data.invoice_number}</span>
                  <p className="invNum">Invoice no</p>
                </div>
                <div className="divider"></div>
                <div className="thirdCard">
                  <div
                    className="second-Data"
                    style={{
                      justifyContent: "flex-end",
                    }}
                  >
                    <div>
                      <span className="text-text-primary">
                        INR <FormatAmount price={data.final_amount_due} />
                      </span>
                      <p className="amountWord">Amount</p>
                    </div>
                  </div>
                  <div className="Action-Data">
                    <div
                      className="cursor-pointer h-icon-lg w-icon-lg z-z-index-base relative global-hover-white flex items-center justify-center rounded-md"
                      onClick={() => dispatch(downloadInvoice(data?.id))}
                    >
                      <SVGComponent
                        btnType="button"
                        url={ICONS?.DOWNLOAD_STATEMENT}
                        height="var(--icon-md)"
                        width="var(--icon-md)"
                      />
                    </div>
                    <div
                      className="cursor-pointer h-icon-lg w-icon-lg z-z-index-base relative global-hover-white flex items-center justify-center rounded-md"
                      onClick={() => {
                        singleStatement(data?.id);
                      }}
                    >
                      <SVGComponent
                        btnType="button"
                        height="var(--icon-md)"
                        width="var(--icon-md)"
                        url={ICONS.VIEW_STATEMENT}
                        color="var(--text-primary)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default InvoicesDetail;
